import React from "react";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import info from "Assets/Icons/info.svg";

const InfoBubble = ({ message }) => {
  const infoMessage = <div style={{ fontSize: "14px" }}>{message}</div>;
  const infoPopover = (
    <Popover
      style={{
        padding: "8px",
        borderRadius: "4px",
        background: "#FFF",
        boxShadow: "0 2px 16px 0 rgba(0, 0, 0, 0.24)",
        border: "none",
      }}
    >
      <Popover.Body
        style={{
          color: "var(--color-text-primary)",
          padding: "0px",
          fontWeight: 400,
          fontSize: "var(--caption-size-medium)",
          fontFamily: "var(--caption-font-family)",
        }}
      >
        {infoMessage}
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      rootClose
      overlay={infoPopover}
    >
      <img
        className="top-menu-icon"
        alt="Info"
        src={info}
        width={20}
        height={20}
      />
    </OverlayTrigger>
  );
};

export default InfoBubble;
